import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MagnifyingGlassChart from './icon-magnifying-glass-chart.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MagnifyingGlassChart {...validProps} />;
}
SvgComponent.iconName = 'magnifyingGlassChart';

/**
 * @deprecated This is a legacy icon
 */
export const MagnifyingGlassChartIcon = svgIconWrapper(SvgComponent);
